import { Button, Modal } from 'react-bootstrap';
import { confirmable, createConfirmation } from 'react-confirm';

interface Parameters {
  titleModal: string;
  message: string;
  cancelButton: string;
  okButton: string;
}
interface Props {
  show: boolean;
  proceed: (result: boolean) => void;
  params: Parameters;
  options: any;
}
const ConfirmDialogComponent = ({ show, proceed, params, options }: Props) => {
  return (
    <Modal show={show} onHide={() => proceed(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{params.titleModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{params.message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => proceed(false)}>
          {params.cancelButton}
        </Button>
        <Button variant="primary" onClick={() => proceed(true)}>
          {params.okButton}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
//<ConfirmDialogComponent {...props} proceed={context.proceed} show={context.show} />
const confirm = createConfirmation(confirmable(ConfirmDialogComponent));

const ConfirmDialog = (params: Parameters, options = {}) => {
  return confirm({ params, options } as any);
};
export default ConfirmDialog;
